<template>
  <div>
    <header class="container-fluid header">
      <section class="row px-3 align-items-center d-flex flex-row">
        <div>
          <img src="../assets/svg/logo.svg" />
        </div>
        <nav
          role="navigation"
          aria-labelledby="main-navigation"
          class="align-self-center"
        >
          <ul
            v-if="this.$store.getters['getUserType'] === 'company'"
            class="none-p-m d-none d-md-flex"
          >
            <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                to="/dashboard"
                :class="currentRouteName == 'dashboard' ? 'active' : ''"
              >
                Dashboard
              </router-link>
            </li>
            <li v-if="!two_factor_auth_required">
              <router-link
                to="/dashboard"
                :class="currentRouteName == 'dashboard' ? 'active' : ''"
              >
                Dashboard
              </router-link>
            </li>
            <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                v-text="$ml.get('menuProgram')"
                to="/program"
                :class="currentRouteName == 'program' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="!two_factor_auth_required">
              <router-link
                v-text="$ml.get('menuProgram')"
                to="/program"
                :class="currentRouteName == 'program' ? 'active' : ''"
              >
              </router-link>
            </li>        
            <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                v-text="$ml.get('menuReport')"
                to="/report"
                :class="currentRouteName == 'report' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="!two_factor_auth_required">
              <router-link
                v-text="$ml.get('menuReport')"
                to="/report"
                :class="currentRouteName == 'report' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li
              v-if="
                isLockerActive &&
                two_factor_auth_required &&
                two_factor_auth_login
              "
            >
              <router-link
                v-text="$ml.get('menuLocker')"
                to="/reportLocker"
                :class="currentRouteName == 'reportLocker' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="isLockerActive && !two_factor_auth_required">
              <router-link
                v-text="$ml.get('menuLocker')"
                to="/reportLocker"
                :class="currentRouteName == 'reportLocker' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                v-text="$ml.get('pentest')"
                to="/pentest"
                :class="currentRouteName == 'pentest' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="!two_factor_auth_required">
              <router-link
                v-text="$ml.get('pentest')"
                to="/pentest"
                :class="currentRouteName == 'pentest' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                to="/ranking"
                :class="currentRouteName == 'ranking' ? 'active' : ''"
              >
                Ranking
              </router-link>
            </li>
            <li v-if="!two_factor_auth_required">
              <router-link
                to="/ranking"
                :class="currentRouteName == 'ranking' ? 'active' : ''"
              >
                Ranking
              </router-link>
            </li>
            <li id="menuAccount">
              <router-link
                v-text="$ml.get('menuAccount')"
                to="/account"
                :class="currentRouteName == 'account' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                v-text="$ml.get('jobBoard')"
                to="/jobs"
                :class="currentRouteName == 'jobs' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li v-if="!two_factor_auth_required">
              <router-link
                v-text="$ml.get('jobBoard')"
                to="/jobs"
                :class="currentRouteName == 'jobs' ? 'active' : ''"
              >
              </router-link>
            </li>
          </ul>
          <ul
            v-if="this.$store.getters['getUserType'] === 'hacker'"
            class="none-p-m d-none d-md-flex"
          >
            <li>
              <router-link
                to="/dashboard"
                :class="currentRouteName == 'dashboard' ? 'active' : ''"
              >
                Dashboard
              </router-link>
            </li>
            <li>
              <router-link
                v-text="$ml.get('menuProgram')"
                to="/program"
                :class="currentRouteName == 'program' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li>
              <router-link
                v-text="$ml.get('menuReport')"
                to="/report"
                :class="currentRouteName == 'report' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li id="navMenuSafe">
              <router-link
                v-text="$ml.get('menuLocker')"
                to="/reportLocker"
                :class="currentRouteName == 'reportLocker' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li>
              <router-link
                to="/ranking"
                :class="currentRouteName == 'ranking' ? 'active' : ''"
              >
                Ranking
              </router-link>
            </li>
            <li id="menuAccount">
              <router-link
                v-text="$ml.get('menuAccount')"
                to="/account"
                :class="currentRouteName == 'account' ? 'active' : ''"
              >
              </router-link>
            </li>
            <li>
              <router-link
                v-text="$ml.get('jobBoard')"
                to="/jobs"
                :class="currentRouteName == 'jobs' ? 'active' : ''"
              >
              </router-link>
            </li>
          </ul>
        </nav>

        <nav class="ml-auto">
          <ul class="none-p-m d-flex align-items-center">
            <li class="m-0 dropleft" @click="$refs.dpdLanguage.show()">
              <img
                v-if="this.$ml.current == 'portuguese'"
                src="../assets/svg/flags/br.svg"
                class="flag pointer"
                aria-haspopup="true"
                aria-expanded="false"
              />
              <img
                v-if="this.$ml.current == 'english'"
                src="../assets/svg/flags/us.svg"
                class="flag pointer"
                aria-haspopup="true"
                aria-expanded="false"
              />
              <img
                v-if="this.$ml.current == 'spanish'"
                src="../assets/svg/flags/es.svg"
                class="flag pointer"
                aria-haspopup="true"
                aria-expanded="false"
              />
            </li>

            <li @click="$refs.dpdNotification.show()" class="dropleft pt-1">
              <span
                class="notify no"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <svg width="16" height="16" class="mb-1">
                  <image
                    xlink:href="../assets/icons/bell.svg"
                    width="16"
                    height="16"
                  />
                </svg>
                <span v-show="totalNotifications > 0" class="notify-badge">{{
                  totalNotifications
                }}</span>
              </span>
            </li>

            <li class="d-none d-md-flex pt-1">
              <a
                @click="logoff()"
                class="row justify-content-start pointer link no"
              >
                <img
                  src="../assets/icons/times-circle-white.svg"
                  class="ico-17"
                />
              </a>
            </li>
            <li class="d-flex d-md-none ml-2">
              <a class="navbar-toggle no pointer" v-b-toggle.accordion-1>
                <svg width="16" height="16">
                  <image
                    xlink:href="../assets/icons/bars.svg"
                    width="16"
                    height="16"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </nav>

        <b-dropdown
          ref="dpdNotification"
          right
          split
          class="dropdown-links drop-language"
        >
          <a
            v-show="!notifications.length"
            class="row dropdown-item h-notification"
          >
            <div class="my-2 pointer">
              <h3
                class="text-center"
                v-text="$ml.get('noNotificationsAvailable')"
              >
                Nenhuma notificação disponível
              </h3>
            </div>
          </a>

          <div
            v-for="(item, index) in notifications"
            :key="index"
            :class="
              'row dropdown-item h-notification d-flex pl-2 py-2 mx-2 ' +
              (notifications.length - 1 != index ? 'border-bottom' : '')
            "
          >
            <div
              v-if="
                ![
                  'mati_validation_required',
                  'mati_validation_required_for_report_payment',
                  'mati_validation_required_for_nda',
                ].includes(item.notification_type)
              "
              class="d-flex justify-content-center align-items-center"
            >
              <b-form-checkbox
                :id="item._id"
                v-model="notificationSelected"
                :name="item._id"
                :value="item._id"
                unchecked-value=""
              />
            </div>

            <div class="col">
              <a
                v-if="
                  ['program_two_factor_auth'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div class="d-flex col w-100 pointer row">
                  <h3 v-text="$ml.get('authentication')">Autenticação</h3>
                  <p>
                    {{ $ml.get("attention") }}
                    {{
                      IsJsonString(item.message).two_factor_auth_active
                        ? `${$ml.get("itWas")} ${$ml.get("enable2fa")}`
                        : `${$ml.get("itWas")} ${$ml.get("disable2fa")}`
                    }}
                    {{ $ml.get("toProgram") }}
                    {{ IsJsonString(item.message).program_name }}
                  </p>

                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="
                  ['program_credentials_created'].includes(
                    item.notification_type,
                  )
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPageProgram(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('availableCredential')">
                    Credencial disponível
                  </h3>
                  <p class="w-100" style="margin-bottom: 5px; margin-top: 2px">
                    {{ $ml.get("program") }}:
                    {{ IsJsonString(item.message).program_name }}
                  </p>

                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="
                  ['report_review_requested'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('reviewRequestedNotification')">
                    Solicitação de revisão
                  </h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="
                  [
                    'report_company_commented',
                    'report_hacker_commented',
                  ].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('newComment')">Novo comentário</h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="['program_nda_updated'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="$router.push('program/invitations')"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('ndaChange')">Mudança de NDA</h3>
                  <p
                    class="w-100"
                    style="margin-bottom: 5px; margin-top: 2px"
                    v-text="
                      $ml
                        .with(
                          'programName',
                          IsJsonString(item.message).program_name,
                        )
                        .get('notificationUpdatedNDA')
                    "
                  ></p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="
                  ['report_bounty_payment_requested'].includes(
                    item.notification_type,
                  )
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('paymentRequested')">
                    Pagamento solicitado
                  </h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_name }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="
                  ['report_retest_requested'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3>{{ $ml.get("retestRequested") }}</h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font>Status</font>:
                    {{ $ml.get(IsJsonString(item.message).retest_status) }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="
                  ['report_evaluate_retest'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3>{{ $ml.get("evaluatedRetest") }}</h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font>Status</font>:
                    {{ $ml.get(IsJsonString(item.message).retest_status) }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="['report_submit_retest'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3>{{ $ml.get("retestSent") }}</h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font>Status</font>:
                    {{
                      $ml.get(
                        "retest_" + IsJsonString(item.message).retest_status,
                      )
                    }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="
                  ['company_two_factor_auth_required'].includes(
                    item.notification_type,
                  )
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('authentication')">Autenticação</h3>
                  <p>
                    {{ $ml.get("attention") }}
                    {{
                      IsJsonString(item.message).two_factor_auth_active
                        ? `${IsJsonString(item.message).company_name} ${$ml.get(
                            "enable2fa",
                          )}`
                        : `${
                            IsJsonString(item.message).company_name
                          }, ${$ml.get("disable2fa")}`
                    }}
                  </p>
                  <p
                    v-show="
                      IsJsonString(item.message).two_factor_auth_active == true
                    "
                    class="link-account"
                  >
                    <span
                      @click="navigateToAccount"
                      v-text="$ml.get('configureNow')"
                      >{{ $ml.get("configureNow") }}</span
                    >
                  </p>
                </div>
              </a>
              <a
                v-if="['report_created'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 class="text-red" v-text="$ml.get('newReport')">
                    Novo relatório
                  </h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['campaign_initiated'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPageProgram(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('doubleCampaignNotificationStarted')">
                    Campanha de bonificação iniciada
                  </h3>
                  <p class="w-100">
                    <font class="description-double-campaign"
                      >{{ $ml.get("notificationAttention") }}
                      <span class="mark-double-campaign">{{
                        $ml.get("notificationYourCampaignHasStarted")
                      }}</span>
                    </font>
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-80">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['campaign_finished'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPageProgram(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('doubleCampaignNotificationClosed')">
                    Campanha de bonificação encerrada
                  </h3>
                  <p class="w-100">
                    <font class="description-double-campaign"
                      >{{ $ml.get("notificationAttention") }}
                      {{ $ml.get("notificationThisCampaign") }}
                      <span class="mark-double-campaign"
                        >{{ $ml.get("notificationHasClosed") }}.</span
                      ></font
                    >
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-80">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['campaign_paused'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPageProgram(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('doubleCampaignNotificationPaused')">
                    Campanha de bonificação pausada
                  </h3>
                  <p class="w-100">
                    <font class="description-double-campaign"
                      >{{ $ml.get("notificationAttention") }}
                      {{ $ml.get("notificationThisCampaign") }}
                      <span class="mark-double-campaign"
                        >{{ $ml.get("notificationHasBeenPaused") }}<br />
                        {{ $ml.get("keepAnEyeOutNotification") }}</span
                      >
                      {{
                        $ml.get("notificationWillLetYouKnowWhenToStartAgain")
                      }}
                    </font>
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-80">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['campaign_resumed'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPageProgram(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('doubleCampaignNotificationResumed')">
                    Campanha de bonificação retomada
                  </h3>
                  <p class="w-100">
                    <font class="description-double-campaign"
                      >{{ $ml.get("notificationAttention") }}
                      <span class="mark-double-campaign">{{
                        $ml.get("notificationThisCampaignIsLiveAgain")
                      }}</span></font
                    >
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-80">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['closure_requested'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('closingRequestTitle')">
                    Solicitação de encerramento
                  </h3>
                  <p class="w-100">
                    <font class="description-double-campaign"
                      >{{ $ml.get("shutdownNotificationMessage") }}
                      {{ IsJsonString(item.message).report_title }} <br /><span
                        class="mark-double-campaign"
                        >{{ $ml.get("notificationSeeRequest") }}</span
                      ></font
                    >
                  </p>
                  <p class="w-80">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['response_requested'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('replyNotificationTitle')">
                    Solicitação de resposta
                  </h3>
                  <p class="w-100">
                    <font class="description-double-campaign"
                      >{{ $ml.get("notificationResponseReport") }}
                      {{ IsJsonString(item.message).report_title }} <br /><span
                        class="mark-double-campaign"
                        >{{ $ml.get("notificationSeeRequest") }}</span
                      ></font
                    >
                  </p>
                  <p class="w-80">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="['report_closed'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('closedReport')">Relatório fechado</h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>
              <a
                v-if="
                  ['report_severity_updated'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('changedReportSeverity')">
                    Severidade do relatório alterada
                  </h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="
                  ['report_updated_situation'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('changedReportStatus')">
                    Situação do relatório alterada
                  </h3>
                  <p class="w-100">
                    <font v-text="$ml.get('report')">Relatório</font>:
                    {{ IsJsonString(item.message).report_title }}
                  </p>
                  <p class="w-100">
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
              </a>

              <a
                v-if="
                  ['password_update_required'].includes(item.notification_type)
                "
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('passwordUpdateRequired')">
                    Atenção! Altere sua senha para evitar o bloqueio desta
                    conta!
                  </h3>
                  <p
                    class="w-100"
                    v-if="IsJsonString(item.message).amount_diff_days"
                  >
                    <font v-text="$ml.get('dashMsgYouHave')">Você tem</font>
                    {{ IsJsonString(item.message).amount_diff_days }}
                    <font v-text="$ml.get('remainingDaysToUpdateYourPassword')"
                      >dias restantes para atualizar sua senha.</font
                    >
                  </p>
                  <p class="w-100" v-else>
                    <font v-text="$ml.get('dashMsgYouHave')">Você tem</font>
                    0
                    <font v-text="$ml.get('remainingDaysToUpdateYourPassword')"
                      >dias restantes para atualizar sua senha.</font
                    >
                  </p>
                </div>
              </a>

              <a
                v-if="['password_expired'].includes(item.notification_type)"
                class="pl-2 align-self-start row"
              >
                <div
                  @click="pushPage(item)"
                  class="d-flex col w-100 pointer row"
                >
                  <h3 v-text="$ml.get('passwordExpiredNotificationTitle')">
                    Atenção! Sua senha expirou!
                  </h3>
                  <p class="w-100">
                    <font v-text="$ml.get('passwordExpiredInstructions')"
                      >Sua conta será bloqueada temporariamente. Mantenha sua
                      senha atualizada e siga as instruções enviadas ao e-mail
                      associado a esta conta.</font
                    >
                  </p>
                </div>
              </a>

              <a
                v-if="
                  ['mati_validation_webhook'].includes(item.notification_type)
                "
                class="pl-2 align-self-start"
              >
                <div
                  @click="hideComent(item)"
                  v-if="IsJsonString(item.message).mati_result == 'verified'"
                  class="row pointer col-24"
                >
                  <h3
                    v-text="$ml.get('congratulationsYourUsernameIsNowVerified')"
                  >
                    Parabéns, agora seu usuário é verificado
                  </h3>
                  <img
                    src="../../src/assets/icons/badge-check.png"
                    class="ml-1 img-verified-notifi"
                  />
                  <p>
                    <font v-text="$ml.get('date')">Data</font>:
                    {{ $utils.formatDataLong(item.createdAt) }}
                  </p>
                </div>
                <div v-else class="row col-24">
                  <div class="d-flex col w-100 row">
                    <!-- <h3 v-text="$ml.get('opssMatiDidntApproveYourData')">
                      Opss, a Mati não aprovou seus dados.
                    </h3> -->
                    <p
                      class="w-100"
                      v-text="$ml.get('ongoingProfileVerification')"
                    >
                      Seu perfil está sendo verificado!
                    </p>
                    <p class="w-100">
                      <font v-text="$ml.get('date')">Data</font>:
                      {{ $utils.formatDataLong(item.createdAt) }}
                    </p>
                  </div>
                </div>
              </a>

              <a
                v-if="
                  ['mati_validation_required'].includes(item.notification_type)
                "
                @click="showMati(item)"
                class="pl-2 align-self-start pointer"
              >
                <h3>
                  <font v-text="$ml.get('profileVerifiedReleased')"
                    >Perfil verificado liberado</font
                  >
                </h3>
                <p class="w-100">
                  {{ $ml.get('ndaVerificationRequired') }}
                </p>
                <!-- <div v-html="buttomMati"></div> -->
                <div @click="showMati(item)" class="custom-btn-docusign mt-3">
                  <div class="logo-docusign">
                     <img src="../assets/icons/docusign.png" alt="logo">
                  </div>
                  <span v-text="$ml.get('validateProfile')">Validar Perfil</span>
                </div>
              </a>
              
              <a
                v-else-if="
                  ['mati_validation_required_for_report_payment'].includes(
                    item.notification_type,
                  )
                "
                @click="showMati(item)"
                class="pl-2 align-self-start pointer"
              >
                <h3 class="mb-3 ml-4" style="color: #730ba9 !important">
                  <font v-text="$ml.get('profileVerifiedReleased')"
                    >Verificação de perfil</font
                  >
                </h3>

                <h3
                  class="mb-2 ml-4"
                  v-text="
                    $ml.get('reportPaymentVerificationRequired1') +
                    item.message + ' ' +
                    $ml.get('reportPaymentVerificationRequired2')
                  "
                ></h3>

                <p
                  class="w-100 ml-4"
               
                >
                {{ $ml.get('ndaVerificationRequired6') }}
                </p>
                <!-- <div v-html="buttomMati"></div> -->
                <div  class="custom-btn-docusign mt-3" @click="showMati(item)">
                  <div class="logo-docusign">
                     <img src="../assets/icons/docusign.png" alt="logo">
                  </div>
                  <span v-text="$ml.get('validateProfile')">Validar Perfil</span>
                </div>
              </a>

              <a
                v-else-if="
                  ['mati_validation_required_for_nda'].includes(
                    item.notification_type,
                  )
                "
                @click="showMati(item)"
                class="pl-2 align-self-start pointer"
              >
                <h3 class="mb-3 ml-4" style="color: #730ba9 !important">
                  <font v-text="$ml.get('profileVerifiedReleased')"
                    >Verificação de perfil</font
                  >
                </h3>

                <h3
                  class="mb-2 ml-4"
                  v-text="
                    $ml.get('ndaVerificationRequired1') + item.message + '.'
                  "
                ></h3>

                <p
                  class="w-100 ml-4"
                  v-text="$ml.get('ndaVerificationRequired2')"
                >
                  {{ $ml.get('ndaVerificationRequired2') }}
                
              </p>
                <!-- <div v-html="buttomMati"></div> -->
                <div @click="showMati(item)" class="custom-btn-docusign mt-3">
                  <div class="logo-docusign">
                     <img src="../assets/icons/docusign.png" alt="logo">
                  </div>
                  <span v-text="$ml.get('validateProfile')">Validar Perfil</span>
                </div>
              </a>
            </div>
          </div>

          <div v-show="notifications.length" class="w-100">
            <hr />
            <div class="d-flex justify-content-center pb-2">
              <a
                @click="hideNotification('', notificationSelected)"
                class="mx-2 px-2 pointer d-flex align-items-center"
                >Selecionadas
                <img
                  class="mx-2 p-0"
                  width="13"
                  src="../../src/assets/icons/trash-alt.svg"
                />
              </a>
              <a
                @click="hideNotification('-all', '')"
                class="mx-2 px-2 pointer d-flex align-items-center"
                >Todas
                <img
                  class="mx-2 p-0"
                  width="13"
                  src="../../src/assets/icons/trash-alt.svg"
                />
              </a>
            </div>
          </div>
        </b-dropdown>

        <b-dropdown
          ref="dpdLanguage"
          right
          split
          class="dropdown-links drop-language"
        >
          <div class="dropdown-item h-notification d-flex pt-3 pb-3">
            <a
              @click="alterLanguage('english')"
              id="flag-change-us"
              class="d-flex no pointer"
            >
              <div class="align-self-start">
                <img src="../assets/svg/flags/us.svg" />
              </div>
              <div class="pl-2 align-self-start no">
                <h3>English</h3>
                <p>Change primary language to English</p>
              </div>
            </a>
          </div>
          <div class="dropdown-divider m-0 mb-2"></div>
          <div class="dropdown-item h-notification d-flex pb-3">
            <a
              @click="alterLanguage('portuguese')"
              id="flag-change-br"
              class="d-flex no pointer"
            >
              <div class="align-self-start">
                <img src="../assets/svg/flags/br.svg" />
              </div>
              <div class="pl-2 align-self-start no">
                <h3>Português</h3>
                <p>Trocar o idioma padrão para Português</p>
              </div>
            </a>
          </div>
          <div class="dropdown-divider m-0 mb-2"></div>
          <div class="dropdown-item h-notification d-flex pb-3">
            <a
              @click="alterLanguage('spanish')"
              id="flag-change-es"
              class="d-flex no pointer"
            >
              <div class="align-self-start">
                <img src="../assets/svg/flags/es.svg" />
              </div>
              <div class="pl-2 align-self-start no">
                <h3>Español</h3>
                <p>Cambiar idioma por defecto a Español</p>
              </div>
            </a>
          </div>
        </b-dropdown>
      </section>
      <b-collapse
        id="accordion-1"
        accordion="my-accordion"
        class="ml-3 mt-1"
        role="tabpanel"
      >
        <ul
          v-if="this.$store.getters['getUserType'] === 'company'"
          class="none-p-m nav navbar-nav"
        >
          <li v-if="two_factor_auth_required && two_factor_auth_login">
            <router-link
              to="/dashboard"
              data-toggle="collapse"
              class="nav-sub active mt-2"
            >
              Dashboard
            </router-link>
          </li>
          <li v-if="!two_factor_auth_required">
            <router-link
              to="/dashboard"
              data-toggle="collapse"
              class="nav-sub active mt-2"
            >
              Dashboard
            </router-link>
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login">
            <router-link
              v-text="$ml.get('menuProgram')"
              to="/program"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Programa
            </router-link>
          </li>
          <li v-if="!two_factor_auth_required">
            <router-link
              v-text="$ml.get('menuProgram')"
              to="/program"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Programa
            </router-link>
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login">
            <router-link
              v-text="$ml.get('menuReport')"
              to="/report"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Relatórios
            </router-link>
          </li>
          <li v-if="!two_factor_auth_required">
            <router-link
              v-text="$ml.get('menuReport')"
              to="/report"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Relatórios
            </router-link>
          </li>

          <li
            v-if="
              isLockerActive &&
              two_factor_auth_required &&
              two_factor_auth_login
            "
          >
            <router-link
              v-text="$ml.get('menuLocker')"
              to="/reportLocker"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Relatórios
            </router-link>
          </li>
          <li v-if="isLockerActive && !two_factor_auth_required">
            <router-link
              v-text="$ml.get('menuLocker')"
              to="/reportLocker"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Relatórios
            </router-link>
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login">
            <router-link
              to="/ranking"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Ranking
            </router-link>
          </li>
          <li v-if="!two_factor_auth_required">
            <router-link
              to="/ranking"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Ranking
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('menuAccount')"
              to="/account"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Minha conta
            </router-link>
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login">
              <router-link
                v-text="$ml.get('jobBoard')"
                to="/jobs"
                data-toggle="collapse"
                class="nav-sub active"
              >
              </router-link>
          </li>
          <li v-if="!two_factor_auth_required">
              <router-link
                v-text="$ml.get('jobBoard')"
                to="/jobs"
                data-toggle="collapse"
                class="nav-sub active"
              >
              </router-link>
          </li>
          <li>
            <a
              href=""
              @click="logoff()"
              v-text="$ml.get('exit')"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Sair
            </a>
          </li>
        </ul>
        <ul
          v-if="this.$store.getters['getUserType'] === 'hacker'"
          class="none-p-m nav navbar-nav"
        >
          <li>
            <router-link
              to="/dashboard"
              data-toggle="collapse"
              class="nav-sub active mt-2"
            >
              Dashboard
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('menuProgram')"
              to="/program"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Programa
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('menuReport')"
              to="/report"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Relatórios
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('menuLocker')"
              to="/reportLocker"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Relatórios
            </router-link>
          </li>
          <li>
            <router-link
              to="/ranking"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Ranking
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('menuAccount')"
              to="/account"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Minha conta
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('jobBoard')"
              to="/jobs"
              data-toggle="collapse"
              class="nav-sub active"
            >
            </router-link>
          </li>
          <li>
            <a
              href=""
              @click="logoff()"
              v-text="$ml.get('exit')"
              data-toggle="collapse"
              class="nav-sub active"
            >
              Sair
            </a>
          </li>
        </ul>
      </b-collapse>
    </header>

    <div v-show="toast" class="backgroundToast">
      <b-toast
        class="position-absolute nd-0 mt-2 toastInactive mr-4"
        v-model="toast"
        id="toast-desconect"
        static
        no-auto-hide
      >
        <h6>
          <span>Não conseguimos detectar nenhuma atividade recente </span>
        </h6>
        <br />
        <p class="text-danger">Mas calma, é só fazer o login novamente. 😉</p>
        <div class="justify-content-center d-flex align-itens-center">
          <a @click="disconnectUser()" class="btn btn-primary w-100">Fazer Login</a>
        </div>
      </b-toast>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
const moment = require("moment");
import axios from "axios";
import io from "socket.io-client";
import { mapActions } from "vuex";
import NotificationService from "../services/notification.service";
import programService from "../services/program.service";
import store from "../state/store";
export default {
  components: {},
  data() {
    return {
      seconds: 50,
      tokenExpirationChecker: null,
      safeRefreshMinutes: null,
      safeRefreshSeconds: null,
      toast: null,

      matiShow: false,
      buttomMati: "",

      notificationSelected: [],

      notifications: [],
      totalNotifications: 0,
      two_factor_auth_required: "",
      two_factor_auth_login: "",
      getUserType: "",
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.meta.name;
    },
    isLockerActive() {
      return this.$store.state.currentUser?.lockerSettings?.status === "active"
        ? true
        : false;
    },
  },

  watch: {
    "$store.state.timeInactive": function () {
      let dateToken = new Date(this.$store.state.timeInactive);
      this.time(dateToken);
    },
    "$store.state.safeTimeInactive": function () {
      let safeDateToken = new Date(this.$store.state.safeTimeInactive);
      localStorage.setItem('timeLockerUpdate', safeDateToken);
      // this.safeTime(safeDateToken);
      this.remainingTime(safeDateToken);
    },
    "$store.getters.getTwoFactorAuthLogin": function () {
      this.two_factor_auth_login = this.$store.getters["getTwoFactorAuthLogin"];
    },
  },

  destroyed() {
    clearInterval(this.tokenExpirationChecker);
    clearInterval(this.safeRefreshMinutes);
    clearInterval(this.safeRefreshSeconds);
  },

  beforeUpdate(){
    let safeDateToken = new Date(this.$store.state.safeTimeInactive);
    if(safeDateToken != 'Invalid Date'){
      this.remainingTime(safeDateToken);
    }
  },

  mounted() {
    const dataLocker = localStorage.getItem('timeLockerUpdate');
    const dataFomarted = new Date(dataLocker);
    if(dataFomarted){
      this.safeTime(dataFomarted);
      this.remainingTime(dataFomarted);
    }
    this.two_factor_auth_required =
      this.$store.getters["getTwoFactorAuthRequired"];
    this.two_factor_auth_login = this.$store.getters["getTwoFactorAuthLogin"];
    this.getUserType = this.$store.getters["getUserType"];

    setTimeout(() => {
      this.getSocket();
    }, 300);
  },

  methods: {
    ...mapActions(["resetUser", "setUser", "setRouteTo", "resetCacheReport"]),

    remainingTime(dateToken) {
      clearInterval(this.safeRefreshMinutes);

      this.safeRefreshMinutes = setInterval(() => {
        const now = moment(); 
        const tokenExpiration = moment(dateToken); 

        // Calcula a diferença de tempo entre agora e a expiração do token
        const duration = moment.duration(tokenExpiration.diff(now));

        const hours = String(duration.hours()).padStart(2, '0');
        const minutes = String(duration.minutes()).padStart(2, '0');
        const seconds = String(duration.seconds()).padStart(2, '0');

        this.formattedTime = `${hours}:${minutes}:${seconds}`;
        localStorage.setItem('remainingTime', this.formattedTime);


        const tokenSafe = localStorage.getItem("token_safe")
        if(!tokenSafe){
          localStorage.setItem('remainingTime', '');
          clearInterval(this.safeRefreshMinutes);
        }

        if (hours <= 0 && minutes <= 0 && seconds <= 0) {
          localStorage.setItem("token_safe", "");
          store.dispatch("setTokenSafe", "");

          clearInterval(this.safeRefreshMinutes);
        }

      }, 1000); 
    },

    navigateToAccount() {
      this.$router
        .push({ name: "account", params: { authentication: "authentication" } })
        .catch(() => {});
    },

    IsJsonString(str) {
      if (
        /^[\],:{}\s]*$/.test(
          str
            .replace(/\\["\\\/bfnrtu]/g, "@")
            .replace(
              /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
              "]",
            )
            .replace(/(?:^|:|,)(?:\s*\[)+/g, ""),
        )
      ) {
        //the json is ok
        return JSON.parse(str);
      } else {
        //the json is not ok
        return String(str);
      }
    },

    pushPage(item) {
      this.$refs.dpdNotification.hide();
      if (
        [
          "report_retest_requested",
          "report_company_commented",
          "report_hacker_commented",
          "report_severity_updated",
          "report_closed",
          "report_created",
          "report_bounty_payment_requested",
          "report_updated_situation",
          "closure_requested",
          "response_requested",
          "report_review_requested",
        ].includes(item.notification_type)
      ) {
        let report_id = JSON.parse(item.message).report_id;
        this.$router
          .push("/report/details?" + report_id)
          .then(() => this.$router.go());
      }
    },
    pushPageProgram(item) {
      this.$refs.dpdNotification.hide();
      if (
        [
          "campaign_initiated",
          "campaign_finished",
          "campaign_paused",
          "campaign_resumed",
          "program_credentials_created",
        ].includes(item.notification_type)
      ) {
        let report_id = JSON.parse(item.message).program_id;
        this.$router
          .push("/program/detail?" + report_id)
          .then(() => this.$router.go());
      }
    },

    hideNotification(type, item) {
      this.$refs.dpdNotification.hide();
      NotificationService.putNotificationHide(type, item).then(() => {
        // this.getSocket();
      });
    },

    getSocket() {
      var authToken = this.$store.getters["getToken"];
      var self = this;

      const socket = io(`${process.env.VUE_APP_WEBSOCKET_URL}`, {
        // const socket = io('http://127.0.0.1:2095', {
        allowUpgrades: true,
        reconnect: true,
        reconnectionAttempts: 10, 
        reconnectionDelay: 5000, 
        timeout: 30000, 
        transports: ['websocket'],
        // path: '/notification',
        query: {
          token: authToken,
        },
      });

      socket.on("connect", function () {
        // console.log("🚀 ~ file: ~ file: header.vue:1082 ~ socket:", socket);
        if (socket.connected) {
          socket.emit("getNotifications");
          socket.on("notifications", (response) => {
            let notifications = response.notifications;
            self.notifications = notifications;
            self.totalNotifications = response.total ? response.total : 0;

            if (  
              notifications[0] &&
              [
                "mati_validation_required",
                "program_nda_updated",
                "mati_validation_required_for_report_payment",
                "mati_validation_required_for_nda",
              ].includes(notifications[0].notification_type)
            ) {
              self.buttomMati = ` 
                <mati-button v-if="matiShow" class="my-2 d-flex align-itens-center mx-4 pt-2 mati-button"
                  clientid="60904febf0a740001bd4f32d" 
                  flowId="60904febf0a740001bd4f32c" 
                  metadata='{ "token": "${notifications[0].mati_token}" }'
                />   
              `;
            }
            notifications.forEach((element) => {
              if (
                element.notification_type == "mati_validation_webhook" &&
                JSON.parse(element.message).mati_result == "verified"
              ) {
                self.setUser({
                  verified: true,
                });
              }
            });
          });
        }
      });
      
      socket.on("connect_error", (err) => {
        console.error("Erro ao conectar ao socket:", err.message);
      });

      socket.on("disconnect", (reason) => {
        console.warn("Socket desconectado:", reason);
      });

      socket.on("reconnect_attempt", (attempt) => {
        console.log(`Tentativa de reconexão (${attempt})`);
      });

    },

    disconnectUser(){
      var self = this;
      self.resetUser();
      self.$router.push("/login");
      localStorage.setItem("token", "");
      localStorage.removeItem("token_safe");
    },

    logoff() {
      var self = this;
      self.resetUser();
      localStorage.setItem("token", "");
      localStorage.removeItem("token_safe");
 
      axios
        .post(self.$apiUrlAuth + `logout`)
        .then(() => {
          self.$router.push("/login");
        })
        .catch(function () {
          self.$router.push("/login");
        });
    },

    async pageReload(timeMs) {
      await setTimeout(() => {
        window.location.reload();
      }, timeMs);
    },

    async alterLanguage(language) {
      this.$refs.dpdLanguage.hide();
      this.$ml.change(language);
      const ln =
        language === "english" ? "en" : language === "portuguese" ? "pt" : "es";
      await this.changeLanguage(ln);
      const milliseconds = 1;
      await this.pageReload(milliseconds);
    },

    time(dateToken) {
      clearInterval(this.tokenExpirationChecker);
      this.$bvToast.hide("toast-desconect");

      this.tokenExpirationChecker = setInterval(() => {
        const now = moment(new Date()); // Data de hoje
        const past = moment(dateToken); // Data de expiração do token
        const duration = moment.duration(now.diff(past));

         if (duration._data.hours >= 0 && duration._data.minutes >= 0 && duration._data.seconds  >= 0) {
          this.showToast();
          clearInterval(this.tokenExpirationChecker);
        }
      }, 1000);
    },

    safeTime(dateToken) {
      clearInterval(this.safeRefreshMinutes);
      clearInterval(this.safeRefreshSeconds);

      this.safeRefreshMinutes = setInterval(() => {
        const now = moment(new Date()); // Data de hoje
        const past = moment(dateToken); // Data de expiração do token
        const duration = moment.duration(now.diff(past));

        if (duration._data.hours == 0 && duration._data.minutes == 0) {
          localStorage.setItem("token_safe", "");
          localStorage.setItem("remainingTime", "");
          store.dispatch("setTokenSafe", "");

          clearInterval(this.safeRefreshMinutes);
        }
      }, 1000);
    },

    showToast() {
      this.resetUser();
      localStorage.setItem("token_safe", "");
      this.setRouteTo(this.$route.fullPath);

      this.$bvToast.show("toast-desconect");
    },

    showMati() {
      // this.matiShow = true;
      this.$refs.dpdNotification.hide();
      this.$router.push('account')
    },
    async changeLanguage(ln) {
      await programService.postPreferredLanguage(ln);
    },
  },
};
</script>
<style>
#toast-desconect > .toast-header {
  display: none !important;
}

.toastInactive {
  z-index: 9999;
  right: 0;
  background: white;
  border: 1px solid #fff;
  border-radius: 3px;
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 5%);
  box-shadow: 0 2px 4px rgb(27 31 35 / 15%);
  box-shadow: 0 20px 72px rgb(18 38 63 / 6%), 0 2px 12px rgb(18 38 63 / 10%);
  top: 65px;
}

.toastInactive .toast {
  opacity: 1;
}

.backgroundToast {
  text-align: center !important;
  position: absolute;
  z-index: 9999 !important;
  background: rgba(0, 0, 0, 0.164);
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  display: flex;
  backdrop-filter: blur(8px);
}

body {
  min-height: 100vh;
  height: 100vh;
}

.drop-language {
  top: 20px;
  right: 65px;
}
.img-verified-notifi {
  width: 20px !important;
  height: 20px !important;
  position: absolute;
  right: -27px;
  top: 5px;
  border-radius: 0px !important;
}
.img-remove-notifi {
  width: 17px !important;
  height: 17px !important;
  top: 20px;
  border-radius: 0px !important;
  margin-right: -20px !important;
  cursor: pointer;
}
.red {
  background-color: crimson;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #730ca8;
  background-color: #730ca8;
  -webkit-animation: effect 250ms ease-in;
  animation: effect 250ms ease-in;
}

#mati-button-element {
  font-size: 13px !important;
  height: 25px !important;
}

.description-double-campaigns {
  color: #999999;
}
.mark-double-campaign {
  color: #e10e71;
}
.link-compaign {
  width: 100%;
  text-align: right;
  text-decoration: underline;
  color: #a90b8e;
  cursor: pointer;
  font-size: 14px;
}
.link-account span {
  font-weight: 400;
  color: #460851 !important;
}
.custom-btn-docusign {
  display: flex;
  border: 1px solid #720ba92e;
  border-radius: 4px;
}
.custom-btn-docusign > span {
  flex: 1;
  color: #fff;
  font-weight: 500;
  background: #730ba9;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 0px;
  border-radius: 0px 4px 4px 0px;
  transition-duration: .500ms;
}
.custom-btn-docusign > span:hover {
   background: #6e07a6eb;
}
.logo-docusign {
  padding: 4px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo-docusign > img {
  margin: 0px !important;
}
</style>
